import React from 'react';
// import { ConditionGroup } from '../../ConditionGroup'; // Remove old component
import { PolicyTemplate, Condition } from '../../../types/policy';
import { GraphView } from '../../PolicyVisualizer/GraphView/GraphView'; // Import GraphView
import { Tooltip } from '../../common/Tooltip'; // Import Tooltip component

/**
 * Props interface for the ConditionsTab component (updated)
 * @property policy - The current policy template being edited
 * @property onUpdatePolicy - Callback for updating the entire policy object
 */
interface ConditionsTabProps {
  policy: PolicyTemplate;
  onUpdatePolicy: (updatedPolicy: PolicyTemplate) => void; // New prop for GraphView updates
  // Remove old props specific to ConditionGroup
  // onUpdateConditions: (conditions: Condition[]) => void;
  // onToggleGroupType: () => void;
  // onToggleNot: () => void;
}

/**
 * ConditionsTab component - Renders the interactive GraphView
 * 
 * @example
 * <ConditionsTab
 *   policy={currentPolicy}
 *   onUpdatePolicy={handlePolicyUpdate} 
 * />
 */
export const ConditionsTab: React.FC<ConditionsTabProps> = ({
  policy,
  onUpdatePolicy
  // Remove unused old props
  // onUpdateConditions,
  // onToggleGroupType,
  // onToggleNot
}) => {
  // Remove helper functions specific to ConditionGroup
  /*
  const isRootNot = (): boolean => { ... };
  const getCurrentGroupType = (): 'allOf' | 'anyOf' => { ... };
  const getCurrentConditions = (): Condition[] => { ... };
  */

  // Return GraphView directly. Container styling (padding, flex-grow, overflow) 
  // should be handled by the parent in PolicyEditor.tsx (the tab-content-area div).
  return (
    <div className="flex flex-col space-y-6 w-full min-w-0 border border-gray-200 dark:border-gray-700 rounded-lg p-6 shadow-sm">
      <div className="space-y-4 w-full">
        {/* Header with description */}
        <div className="border-b border-gray-200 dark:border-gray-700 pb-4">
          <div className="flex items-center gap-2 mb-2">
            <h3 className="text-lg font-medium text-gray-900 dark:text-gray-100">
              If Conditions
            </h3>
            <Tooltip 
              content="Define the conditions that determine when this policy should be applied. Use the visual editor to build complex logic with nested conditions."
              position="right"
              maxWidth={400}
            />
          </div>
        </div>

        {/* GraphView for building policy conditions */}
        <div className="flex-grow">
          <GraphView
            policy={policy}
            onUpdate={onUpdatePolicy} // Pass the general update handler
          />
        </div>
      </div>
    </div>
  );
}; 